import { PortalLayout } from "@/components/layout/PortalLayout";
import { GlassCard } from "@/components/GlassCard";

const STEPS = [
  ["Inbound arrival", "Quantus posts new deals to PDG via an HMAC-signed webhook. Each lands in the Sourcing Inbox as restricted and unpublished."],
  ["Triage", "Review each inbound deal. Run ORLA triage to auto-classify sector and deal type and receive a recommendation, then move to Vetting or Underwriting."],
  ["Pipeline progression", "Advance deals through Vetting, Underwriting, and IC Review on the Pipeline board. Nothing is visible to investors until you publish."],
  ["Publish", "Publishing moves a deal to the investor deal board. Restricted deals still require an explicit per-investor access grant."],
  ["Outbound", "Admin-triggered requests to Quantus are queued as integration events, signed with the PDG secret, and retried on failure. Every attempt is logged."],
];

export default function BridgeHowItWorks() {
  return (
    <PortalLayout title="How the Bridge works">
      <div className="max-w-3xl space-y-4">
        {STEPS.map(([t, d], i) => (
          <GlassCard key={t} className="p-6">
            <div className="pdg-mono text-xs text-[hsl(var(--pdg-gold))]">STEP {String(i + 1).padStart(2, "0")}</div>
            <h2 className="mt-2 pdg-serif text-xl text-foreground">{t}</h2>
            <p className="mt-2 text-sm text-muted-foreground leading-7">{d}</p>
          </GlassCard>
        ))}
      </div>
    </PortalLayout>
  );
}
